module.exports = __webpack_public_path__ + "img/one-id.f36ba7cd.png";